<template>
  <div class="scroll-container">
    <v-list-item class="no-scroll">
      <v-list-item-title class="text-h6">{{ $t("PMIFiltersTitle") }}</v-list-item-title>
      <v-list-item-action @click="setSideDrawer(null)" style="cursor: pointer">
        <img class="vis-icon" src="/img/toolbar/Close.svg" />
      </v-list-item-action>
    </v-list-item>
    <v-divider></v-divider>
    <v-list class="pt-0 scroll">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>{{ $t("PMIFiltersDescription") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item>
        <v-list-item-action @click="selectAll">
          <img class="vis-icon" :src="getSelectAllState" />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>{{ $t("SelectAll") }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item v-for="(value, key) in pmiFiltersMap" :key="key">
        <v-list-item-action @click="toggleSelected(key)">
          <img
            class="vis-icon"
            :src="value.selected ? '/img/toolbar/CheckboxChecked.svg' : '/img/toolbar/Checkbox.svg'"
          />
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title v-text="key + ' (' + value.psIds.length + ')'"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";

export default {
  components: {},
  data: () => ({
    numFiltersSelected: 0
  }),
  computed: {
    ...mapState(["pmiFiltersMap", "pmiActive"]),
    ...mapGetters(["viewerManager", "pmiManager"]),
    getSelectAllState: function() {
      if (this.numFiltersSelected === Object.keys(this.pmiFiltersMap).length) {
        return "/img/toolbar/CheckboxChecked.svg";
      } else if (this.numFiltersSelected === 0) {
        return "/img/toolbar/Checkbox.svg";
      } else {
        return "/img/toolbar/CheckboxPartiallyChecked.svg";
      }
    }
  },
  mounted: function() {
    this.$root.$on("modelLoaded", this.newModelLoaded);
    this.numFiltersSelected = Object.keys(this.pmiFiltersMap).length;
  },
  methods: {
    ...mapMutations(["setSideDrawer"]),
    newModelLoaded: function() {},
    selectAll: function() {
      if (this.numFiltersSelected < Object.keys(this.pmiFiltersMap).length) {
        this.numFiltersSelected = Object.keys(this.pmiFiltersMap).length;
        for (var filter1 in this.pmiFiltersMap) {
          this.pmiFiltersMap[filter1].selected = true;
          if (this.pmiFiltersMap[filter1].psIds.length > 0 && this.pmiActive) {
            this.pmiManager.setVisibilityByPsId(this.pmiFiltersMap[filter1].psIds, true);
          }
        }
      } else {
        this.numFiltersSelected = 0;
        for (var filter2 in this.pmiFiltersMap) {
          this.pmiFiltersMap[filter2].selected = false;
          if (this.pmiFiltersMap[filter2].psIds.length > 0 && this.pmiActive) {
            this.pmiManager.setVisibilityByPsId(this.pmiFiltersMap[filter2].psIds, false);
          }
        }
      }
    },
    toggleSelected: function(key) {
      if (this.pmiFiltersMap[key].selected) {
        this.pmiFiltersMap[key].selected = false;
        this.numFiltersSelected -= 1;
        if (this.pmiActive) {
          this.pmiManager.setVisibilityByPsId(this.pmiFiltersMap[key].psIds, false);
        }
      } else {
        this.pmiFiltersMap[key].selected = true;
        this.numFiltersSelected += 1;
        if (this.pmiActive) {
          this.pmiManager.setVisibilityByPsId(this.pmiFiltersMap[key].psIds, true);
        }
      }
    }
  }
};
</script>

<style scoped></style>
